import React from 'react';
import cssClasses from './rules.css';

const Allocation = (props) => {

    const chartItem = props.chart.find(transaction => transaction.value === props.item.AccountCode);
    const accountCode = (props.item.AccountCode.length !== 20) ? props.item.AccountCode : '';
    const accountName = (chartItem) ? `${accountCode ? ' / ' : ''}${chartItem.label}` : '';
    const itemDetail = (props.item.Amount) ? `$${Math.abs(props.item.Amount)}` : `${props.item.Percentage}%`;

    if (props.item.Description && props.item.Description !== 'coded') {
        return (
            <div>
                <span className={cssClasses.ruleColour}>{itemDetail}</span> to <span className={cssClasses.ruleColour}>{`${accountCode}${accountName}`}</span> with description of: <span className={cssClasses.ruleColour}>{props.item.Description}</span>
            </div>
        );
    }

    return (
        <div>
            <span className={cssClasses.ruleColour}>{itemDetail}</span> to <span className={cssClasses.ruleColour}>{`${accountCode}${accountName}`}</span>
        </div>);

};

export default Allocation;



// WEBPACK FOOTER //
// ./src/components/Rules/allocation.js